
























































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import ExtButton from '@/components/ext/Button.vue';
import Share from '@/components/parts/share';
import mixin from '../mixins/mixin.ts';

type Video = {
  id: string | number;
  video: string;
};

type MediaItem =
  | {
      key: string;
      type: 'image';
      src: string;
    }
  | {
      key: string;
      type: 'video';
      html: string;
    };

@Component({
  components: {
    ExtButton,
    Share,
  },
})
export default class ComponentsPartsBlogListCompItem extends Mixins(mixin) {
  @Prop({ type: Array, default: () => [] })
  videos: Array<Video>;

  currentSlide = 0;

  get mediaItems(): Array<MediaItem> {
    const mediaItems: Array<MediaItem> = [];

    if (this.middleThumb) {
      mediaItems.push({
        key: 'image',
        type: 'image',
        src: this.middleThumb,
      });
    }

    const videos = Array.isArray(this.videos) ? this.videos : [];
    videos.forEach((item, index) => {
      if (!item || !item.video) return;

      mediaItems.push({
        key: `video-${item.id || index}`,
        type: 'video',
        html: item.video,
      });
    });

    return mediaItems;
  }

  get hasPrevSlide(): boolean {
    return this.currentSlide > 0;
  }

  get hasNextSlide(): boolean {
    return this.currentSlide + 1 < this.mediaItems.length;
  }

  get getEventType() {
    const ret = this.$store.state.blogEventsDict.find((sprElem: any) => {
      return sprElem.id === this.event_type;
    });
    if (ret) {
      return ret.name;
    }
    return '';
  }

  @Watch('mediaItems.length')
  onMediaItemsLengthChange(length: number): void {
    if (this.currentSlide >= length) this.currentSlide = 0;
  }

  @Watch('middleThumb')
  @Watch('videos')
  resetCurrentSlide(): void {
    this.currentSlide = 0;
  }

  setSlide(index: number): void {
    this.currentSlide = index;
  }

  setNextSlide(): void {
    if (this.hasNextSlide) this.currentSlide += 1;
  }

  setPrevSlide(): void {
    if (this.hasPrevSlide) this.currentSlide -= 1;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/blog/article/Article.vue